// The persona picker for a side pane's composer: a pill in the composer's
// controls row, the same shape as the model picker beside it.
import React from 'react'
import { MenuItem, Select } from '@mui/material'
import { HAIRLINE_COLOR, HAIRLINE_HOVER_COLOR, PILL_RADIUS } from '../../agent'

interface PersonaSelectProps {
  personas: string[]
  value: string
  onChange: (persona: string) => void
  disabled?: boolean
}

const PersonaSelect: React.FC<PersonaSelectProps> = ({ personas, value, onChange, disabled }) => (
  <Select
    size="small"
    value={value}
    onChange={(e) => onChange(String(e.target.value))}
    disabled={disabled}
    inputProps={{ 'aria-label': 'Persona' }}
    sx={{
      height: 36,
      flexShrink: 1,
      minWidth: 0,
      fontSize: 13,
      borderRadius: PILL_RADIUS,
      '& .MuiSelect-select': { py: 0.5, pl: '16px' },
      '& .MuiOutlinedInput-notchedOutline': { borderColor: HAIRLINE_COLOR },
      '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: HAIRLINE_HOVER_COLOR },
      '&.Mui-disabled .MuiOutlinedInput-notchedOutline': { borderColor: HAIRLINE_COLOR },
    }}
  >
    {personas.map((persona) => (
      <MenuItem key={persona} value={persona} sx={{ fontSize: 13 }}>
        {persona}
      </MenuItem>
    ))}
  </Select>
)

export default PersonaSelect
